import { http } from "shared/api/http";
import { ISalesConfiguration } from "sales/models";

const apiPath = `${process.env.REACT_APP_API_BASE_URL}/api/v1/salesconfigurations`;

export const getSalesConfigurations = async () => {
  const res = await http.get<ISalesConfiguration[]>(`${apiPath}`);
  return res?.data;
};

export const upsertSalesConfiguration = async (config: ISalesConfiguration) => {
  try {
    const res = await http.post<ISalesConfiguration>(
      `${apiPath}/upsert`,
      config
    );
    return res?.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const deleteSalesConfiguration = async (id: string) => {
  try {
    const res = await http.delete<string>(`${apiPath}/${id}`);
    return res?.data;
  } catch (error) {
    return Promise.reject(error);
  }
};
